// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609010532/js/" + chunkId + "." + {"44":"04abc477","225":"2f689e38","481":"9c56c53c","486":"9828fc9d","770":"095cbd2f"}[chunkId] + ".0.24396056437712998.chunk.js";
};